export const SPONSOR_TYPES_ACTIONS = {
  SET_SPONSOR_TYPES: 'SET_SPONSOR_TYPES',
  SET_IS_LOADING: 'SET_IS_LOADING',
}
